import React, { useEffect, useState } from 'react';
import axios from 'axios';
import useMilestones from '../../utilities/customHooks/useMilestones';
import { Milestone, StartCompactMilestone } from './milestone';
import { getFormattedStringDate } from '../common/util';

async function saveMilestoneChanges(projectId, milestoneId, change) {
	const endpoint = `${import.meta.env.VITE_ROOT_PATH}/api/milestone-changes/${projectId}/${milestoneId}`;
	const body = { ...change };
	const response = await axios.put(endpoint, body).catch(() => null);
	return response && response.data;
}

async function saveProjectedStartDate(projectId, projectedStartDate) {
	const startingDate = getFormattedStringDate(projectedStartDate);
	const endpoint = `${import.meta.env.VITE_ROOT_PATH}/api/project/start-date/${projectId}`;
	const response = await axios.put(endpoint, {
		startDate: startingDate
	}).catch(() => null);
	return response && response.data;
}

export function getInputDate(value = '') {
		if (typeof value === "string") return value.replace(/Z/g, "");
		else if (value) return new Date(value).toDateString();
		else return value;
}


function CompactMilestones({ project, actions, milestones, startDate, setStartDate }) {
	return (
		<div className="grid row-gap-6 auto-rows-fr">
			<StartCompactMilestone project={project} date={startDate} onChangeDate={setStartDate} />
			{milestones.map(milestone =>
				<Milestone
					key={milestone.id}
					actions={actions}
					milestone={milestone}
				/>
			)}
		</div>
	);
}

export default function Milestones({ project = {}, milestones: ms, onChange }) {
	const { actions, milestones } = useMilestones(ms, Boolean(project.link));
	const [projectedStart, setProjectedStart] = useState(null);

	useEffect(() => {
		if (projectedStart) {
			saveProjectedStartDate(project._id, projectedStart).then(() => {
				if (typeof onChange === 'function') {
					onChange({ type: 'startDate', change: projectedStart });
				}
			});

		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [projectedStart]);

	useEffect(() => {
		actions.reset({
			milestones: ms,
			hasProductionProject: Boolean(project.link)
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [project.link]);

	actions.setOnChange(async ({ id, value, name }) => {
		const changes = await saveMilestoneChanges(project._id, id, { [name]: value });

		actions.reset({
			milestones: changes || ms,
			hasProductionProject: Boolean(project.link)
		});

		if (changes && typeof onChange === 'function') {
			onChange({ type: 'milestones', change: changes });
		}
	});

	const milestoneProps = {
		actions,
		milestones,
		startDate: projectedStart || getInputDate(project.startDate),
		setStartDate: (dateString) => setProjectedStart(dateString)
	};

	return <CompactMilestones {...milestoneProps} project={project} />
}